.list {
  list-style: none;
  margin: 1rem 0;
  padding-left: 0;
}

.item {
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
}
